import { createFileRoute } from '@tanstack/react-router'

import { SmsMessagesPage } from '#/modules/communication/sms-page'
import { validateListSearch } from '#/shared/lib/list-search'

export const Route = createFileRoute('/_shell/sms-messages')({
  component: SmsMessagesPage,
  validateSearch: validateListSearch,
})
